/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'upgrade-management-service';
const pathParameterPlaceholder = undefined;
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * get-/upgrade-management-service/v1/upgrade-configs
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:UpgradeManagementAppResource+type:symbol+get&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Upgrade_Management_App-get-%2Fupgrade-management-service%2Fv1%2Fupgrade-configs'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fupgrade-management-service%2Fv1%2Fupgrade-configs?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const fetchAllUpgradePointsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/upgrade-configs'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * get-/upgrade-management-service/v1/upgrade-configs/{upgradeKey}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:UpgradeManagementAppResource+type:symbol+getUpgradeConfig&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Upgrade_Management_App-get-%2Fupgrade-management-service%2Fv1%2Fupgrade-configs%2F%7BupgradeKey%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fupgrade-management-service%2Fv1%2Fupgrade-configs%2F%28%28%7BupgradeKey%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const fetchUpgradePointByUpgradeKeyRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/upgrade-configs', pathParameterPlaceholder]),
  pathParameters: freeze(['upgradeKey'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * get-/upgrade-management-service/v1/upgrade-config/{upgradeKey}/with-product
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:UpgradeManagementAppResource+type:symbol+getUpgradeConfigWithPurchaseMotions&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Upgrade_Management_App-get-%2Fupgrade-management-service%2Fv1%2Fupgrade-config%2F%7BupgradeKey%7D%2Fwith-product'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fupgrade-management-service%2Fv1%2Fupgrade-config%2F%28%28%7BupgradeKey%7D%29%29%2Fwith-product?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getUpgradeConfigWithPurchaseMotionsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/upgrade-config', pathParameterPlaceholder, 'with-product']),
  pathParameters: freeze(['upgradeKey'])
});